module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/homepage/section-texture-44b4109f3781ad30b8c25367f3e38d11.jpg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/homepage/section-texture.jpg
// module id = YNMk
// module chunks = 9